import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db, auth } from "./firebase";

export const logAudit = async ({
  module,
  action,
  refCollection,
  refDocId,
  sku,
  date,
  oldData,
  newData,
  role
}) => {
  await addDoc(collection(db, "audit_logs"), {
    module,
    action,
    refCollection,
    refDocId,
    sku: sku || "",
    date: date || "",
    oldData: oldData || null,
    newData: newData || null,
    performedBy: auth.currentUser?.uid || "unknown",
    role,
    timestamp: Timestamp.now()
  });
};
